import sanitize from 'sanitize-html';

const defaultOptions: sanitize.IOptions = {
  allowedTags: ['nobr'],
};

export const sanitizeHTML = (html = '', options = defaultOptions): string => {
  return sanitize(html, options);
};
